import {useMutation} from "@tanstack/react-query";
import {CommerceApi, StripeSetupIntentResponse} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useDispatch} from "react-redux";
import {addError} from "@/redux/meta/metaActions";

/**
 * Create a Stripe SetupIntent for adding + verifying a card. The returned
 * clientSecret is confirmed client-side with Elements (stripe.confirmCardSetup),
 * which runs the $0 verification auth where AVS/CVC + Radar are evaluated.
 */
export function useCreateStripeSetupIntent() {
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: async (): Promise<StripeSetupIntentResponse> => {
            return await new CommerceApi(getConfig()).createStripeSetupIntents();
        },
        onError: async (e) => {
            dispatch(await addError(e as any));
        },
    });
}
